const getSocialImage = (socialImage) => {
  let image = {};

  if (socialImage) {
    image = { ...socialImage };
    const { url: { primary: imageUrl } = {} } = socialImage || {};
    image.url = imageUrl;
  }

  return image;
};

export default getSocialImage;
